import SpriteSymbol from "../../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "svg_i-close",
  "use": "svg_i-close-usage",
  "viewBox": "0 0 14 13",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 14 13\" id=\"svg_i-close\"><path d=\"M11.556.707a1 1 0 1 1 1.414 1.414l-9.9 9.9a1 1 0 0 1-1.413-1.414l9.9-9.9Z\" fill=\"currentColor\" /><path d=\"M12.97 10.607a1 1 0 1 1-1.414 1.414l-9.9-9.9A1 1 0 0 1 3.071.708l9.9 9.9Z\" fill=\"currentColor\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol